const TYPES = [
    "instances_fulfilled",
    "instances_unfulfilled",
    "instances_total",
    "instances_error",
];
const TYPED_AS_STATISTIC_TYPE = TYPES.map((type, index) => ({ id: index, name: type }));
export default class WorkflowGroupNodeStatisticTypeDomainService {
    static get Types() {
        return TYPED_AS_STATISTIC_TYPE;
    }
    static get Fulfilled() {
        return TYPED_AS_STATISTIC_TYPE[0];
    }
    static get UnFulfilled() {
        return TYPED_AS_STATISTIC_TYPE[1];
    }
    static get Total() {
        return TYPED_AS_STATISTIC_TYPE[2];
    }
    static Error() {
        return TYPED_AS_STATISTIC_TYPE[3];
    }
}
